module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = main